<!-- ChatListItem.vue -->

<template>
  <div class="chat-list-item bg-hover-light-info px-3" @contextmenu.prevent="showCustomMenu"
       :class="{ active: selected, 'new': contact?.last_message?.is_new }" @click="selectContact">

    <div class="d-flex justify-content-between py-4">
      <div class="d-flex">
        <!-- Avatar or Symbol -->
        <div class="symbol symbol-circle">
          <img src="assets/image/userImgPlaceholder.png" alt="User Image" />
        </div>

        <!-- User Details -->
        <div class="ms-2 d-grid">
          <p class="fs-5 fw-bolder text-gray-900 m-0 d-block overflow-hidden" :title="formattedMobileNumber">
            <span dir="auto" class="hide-over-flow-text d-list-item"
              :class="locale == 'ar' ? 'text-end' : 'text-start'">{{ formattedMobileNumber }}</span>
          </p>
          <p v-if="contact?.last_message?.type == 'text' || (contact?.last_message?.type == 'template' && contact?.last_message?.extra_data?.template?.is_system && !contact?.last_message.linker_payment_status)"
            :class="{ 'text-bolder text-black': contact?.last_message?.is_new }"
            class="d-block h-20px overflow-hidden text-black-50 m-0 d-flex align-items-center gap-1">
              <MessageStatus :data="contact?.last_message" v-if="contact?.last_message?.sent_by_merchant"/>
            <span dir="auto" class="hide-over-flow-text d-list-item">{{ contact?.last_message?.type == 'text' ?  contact?.last_message?.content : contact?.last_message?.extra_data?.template?.components?.[1]?.text }}</span>
          </p>
          <p v-else-if="contact?.last_message?.type == 'button'"
            :class="{ 'text-bolder text-black': contact?.last_message?.is_new }"
            class="d-block h-20px overflow-hidden text-black-50 m-0">
            <span dir="auto" class="hide-over-flow-text d-list-item">{{ contact?.last_message?.content?.text }}</span>
          </p>
          <p v-else-if="contact?.last_message?.type == 'interactive'"
            :class="{ 'text-bolder text-black': contact?.last_message?.is_new }"
            class="d-block h-20px overflow-hidden text-black-50 m-0 d-flex align-items-center gap-1">
              <MessageStatus :data="contact?.last_message" v-if="contact?.last_message?.sent_by_merchant"/>
              <span class="hide-over-flow-text d-list-item"><i class="bi bi-bookmark-dash me-2"
                :class="getInteractiveMessageProps(contact?.last_message)?.icon"></i><span></span>
              {{ getInteractiveMessageProps(contact?.last_message)?.text }}
            </span>
          </p>
          <p v-else-if="contact?.last_message?.type == 'template'"
            :class="{ 'text-bolder text-black': contact?.last_message?.is_new }"
            class="d-block overflow-hidden text-black-50 m-0 campaign-block d-flex align-items-center gap-1">
              <MessageStatus :data="contact?.last_message" v-if="contact?.last_message?.sent_by_merchant"/>
              <span class="hide-over-flow-text d-list-item">
                <i class="bi bi-megaphone-fill me-2"></i>
                <span class="txt">{{ contact?.last_message?.extra_data?.campaign?.name }}</span>
            </span>
          </p>
          <p v-else :class="{ 'text-bolder text-black': contact?.last_message?.is_new }"
            class="d-block h-20px overflow-hidden text-black-50 m-0 d-flex align-items-center gap-1">
              <MessageStatus :data="contact?.last_message" v-if="contact?.last_message?.sent_by_merchant"/>
              <span class="hide-over-flow-text d-list-item"><i class="bi bi-bookmark-dash me-2"
                :class="getMessageType?.icon"></i>{{ getMessageType?.text }}</span>
          </p>
            <div class="mt-1 d-flex align-items-center gap-2">
                <ExpiryStatus :conversationExpirationTimestamp="contact?.conversation_expiration_timestamp"/>
                <Labels :contact="contact" :activeMenu="labelActiveMenu" @set-label-menu="$emit('set-label-menu',$event)"
                    @set-new-labels="setNewLabels"/>
            </div>
        </div>
      </div>
      <!-- Last Seen Information -->
      <div class="text-center ms-2 d-flex flex-column justify-content-between align-items-center pb-3">
        <p class="text-muted fs-7 text-nowrap m-0" :style="locale == 'en' ? 'direction:ltr' : ''"><span
          class="time-label" :class="{'text-danger fw-bold':contact?.last_message?.is_new && !contact?.last_message?.sent_by_merchant, 'text-info fw-bold':contact?.last_message?.is_new && contact?.last_message?.sent_by_merchant}">{{ lastSeen }}</span></p>
        <p v-if="contact?.last_message?.is_new" class="badge badge-circle badge-xs m-0 align-top"
           :class="contact?.last_message?.sent_by_merchant ? 'badge-info' : 'badge-danger'"
          style="top:7px">{{ contact?.last_message?.unreadMessages }}</p>
      </div>
    </div>

    <!-- Separator -->
    <div class="separator separator-dashed d-none"></div>
    <MarkUnreadMenu :contact="contact" ref="markUnreadMenuRef"
                    :activeMenu="activeMenu"
                    @set-active-menu="$emit('set-active-menu', $event)"
                    :tenant="tenant"/>
  </div>
</template>

<script>
import parsePhoneNumber from "libphonenumber-js";
import { InteractiveSubtypes, MessageTypes } from "@/components/whatsapp-managment/interfaces.js"
import { getInteractiveMessageProps } from '@/components/utils.js'
import { ref } from "vue";
import MessageStatus from "./components/MessageStatus";
import ExpiryStatus from "./components/ExpiryStatus";
import MarkUnreadMenu from "./components/MarkUnreadMenu";
import Labels from "./components/Labels";
import {doc, updateDoc} from "firebase/firestore";
import { db } from "@/firebase";

export default {
  props: {
    contact: {
      type: Object,
      required: true,
    },
    locale: String,
    selected: Boolean,
    activeMenu: String,
    labelActiveMenu: String,
      tenant: String
  },
    components:{
        MessageStatus,
        ExpiryStatus,
        MarkUnreadMenu,
        Labels,
    },
    data(){
      return{
          timer: null,
          lastSeen: '',
      }
    },
    watch: {
        'contact.timestamp': function(newValue, oldValue) {
            this.calculateLastSeen();
        },
    },
  computed: {
    getMessageType() {
      const messageType = this.contact?.last_message?.type;
      if (!messageType) return "";

      // Matching the interactive type with the InteractiveSubtypes keys
      switch (messageType) {
        case "order":
          return { 'text': this.$t("Order"), 'icon': 'bi-cart' };
        case "image":
          return { 'text': this.$t("Image"), 'icon': 'bi-image' };
        case "video":
          return { 'text': this.$t("Video"), 'icon': 'bi-camera-video' };
        case "audio":
            return { 'text': this.$t("audio"), 'icon': 'bi-soundwave' };
        case MessageTypes.Document:
            return { 'text': this.$t("file"), 'icon': 'bi-file-earmark-text' };
        case MessageTypes.Location:
            return { 'text': this.$t("location"), 'icon': 'bi-geo-alt' };
        default:
          return { 'text': this.$t("Not Supported Message Title"), 'icon': 'bi-slash-circle' }; // Default case if none matches
      }
    },
    formattedMobileNumber() {
      let rawInput =
        this.contact.profile_name === this.contact.id
          ? this.contact.id
          : (this.contact.contact_display_name ?? this.contact.profile_name);

      if (this.contact.profile_name === this.contact.id) {
        if (rawInput.startsWith('00')) {
          rawInput = rawInput.replace('00', '+');
        }
        try {
          const phoneNumber = parsePhoneNumber(rawInput.includes('+') ? rawInput : `+${rawInput}`);
          const result = phoneNumber.formatInternational();
          return result;
        } catch (error) {
          return rawInput;
        }
      } else {
        // It's treated as a name, so return the original input
        return rawInput;
      }
    },
  },
    mounted() {
        this.calculateLastSeen();
        this.timer = setInterval(this.calculateLastSeen, 60000);
    },
    beforeUnmount() {
        if (this.timer) {
            clearInterval(this.timer);
        }
    },
    methods: {
    setNewLabels(labels){
        // console.log("labels",labels);
        const conversationRef = doc(
            db,
            `tenants/${this.tenant}/conversations`,
            this.contact?.id
        );
        updateDoc(conversationRef, {
            "labels": labels,
        });
    },
     calculateLastSeen(){
         this.lastSeen = this.formatTimestamp();
     },
      formatTimestamp() {
          let timestamp = this.contact.timestamp;
          const timestampLength = timestamp.toString().length;

          // Assume timestamps with more than 13 digits are in microseconds
          if (timestampLength > 13) {
              // Convert microseconds to milliseconds
              timestamp = Math.floor(timestamp / 1000);
          } else {
              timestamp = timestamp * 1000;
          }
          const timestampDate = new Date(timestamp);
          const now = new Date();

          const diffInSeconds = Math.floor((now - timestampDate) / 1000);

          if (diffInSeconds < 60) {
              return diffInSeconds <= 0 ? this.$t('dates.now') : `${diffInSeconds}s`;
          }

          const diffInMinutes = Math.floor(diffInSeconds / 60);
          if (diffInMinutes < 60) {
              return `${diffInMinutes}m`;
          }

          const diffInHours = Math.floor(diffInMinutes / 60);
          if (diffInHours < 24) {
              return `${diffInHours}h`;
          }

          const diffInDays = Math.floor(diffInHours / 24);
          if (diffInDays < 7) {
              return `${diffInDays}d`;
          }

          const diffInWeeks = Math.floor(diffInDays / 7);
          if (diffInWeeks < 4) {
              return `${diffInWeeks}w`;
          }

          const diffInMonths = Math.floor(diffInWeeks / 4);
          if (diffInMonths < 12) {
              return `${diffInMonths}mo`;
          }

          const diffInYears = Math.floor(diffInMonths / 12);
          return `${diffInYears}y`;
      },
      //Old timestamp
    formatTimestamp1(timestamp) {
      // Determine the timestamp length to guess its unit
      const timestampLength = timestamp.toString().length;

      // Assume timestamps with more than 13 digits are in microseconds
      if (timestampLength > 13) {
        // Convert microseconds to milliseconds
        timestamp = Math.floor(timestamp / 1000);
      } else {
        timestamp = timestamp * 1000;
      }

      // Now proceed with your original method, using the adjusted timestamp
      const timestampDate = new Date(timestamp);
      const now = new Date();

      if (
        timestampDate.getFullYear() === now.getFullYear() &&
        timestampDate.getMonth() === now.getMonth() &&
        timestampDate.getDate() === now.getDate()
      ) {
        const options = { hour: 'numeric', minute: '2-digit', hour12: true };
        const formattedTime = timestampDate.toLocaleTimeString([], options);
        return formattedTime
          ? formattedTime.replace('AM', this.$t('AM')).replace('PM', this.$t('PM'))
          : '';
      }

      const yesterday = new Date();
      yesterday.setDate(now.getDate() - 1);

      if (
        timestampDate.getFullYear() === yesterday.getFullYear() &&
        timestampDate.getMonth() === yesterday.getMonth() &&
        timestampDate.getDate() === yesterday.getDate()
      ) {
        return this.$t('Yesterday');
      }

      const formattedDate = `${timestampDate.getFullYear()}-${(timestampDate.getMonth() + 1).toString().padStart(2, '0')}-${timestampDate.getDate().toString().padStart(2, '0')}`;
      return formattedDate;
    },

    selectContact() {
      this.$emit("select-conversation", this.contact);
    },
    showCustomMenu(event) {
        this.$refs.markUnreadMenuRef.showMenu(event);
    },
    getSymbolClasses() {
      // Add logic to determine symbol classes based on your requirements
      return "bg-light-danger text-danger fs-6 fw-bolder";
    },
    truncateMessage(message, length) {
      return message.length > length
        ? `${message.substring(0, length)}...`
        : message;
    },
    getInteractiveMessageProps,
  },

};
</script>

<style scoped lang="scss">
@import './types/styles/chat_list_item.scss';
</style>
